// FILE: src/pages/Services.jsx
import './services.css';

export default function Services() {
  return (
    <div className="services-page container-fluid px-3 py-5">
      <h2 className="text-center mb-4">Our Services</h2>
      <p className="text-center mb-5">Explore the specialized services we offer across maritime and hospitality industries.</p>

      {/* ✅ Grid of service cards */}
      <div className="row g-4 mb-5">
        
        <div className="col-md-4" >
          <div className="service-card p-4 rounded shadow-sm h-100">
            <section className='hover-fill'>
            <h4>Ship Crew Manning</h4>
            <p>Recruitment and deployment of qualified seafarers for cargo and cruise vessels globally.</p>
            </section>
          </div>
        </div>
        
        <div className="col-md-4">
          <div className="service-card p-4 rounded shadow-sm h-100">
            <section className='hover-reveal'>
            <h4>Hotel Staffing</h4>
            <p>Trained hospitality professionals for luxury ships, resorts, and floating hotels.</p>
            </section>
          </div>
        </div>
        <div className="col-md-4">
          <div className="service-card p-4 rounded shadow-sm h-100">
            <section className='hover-fill'>
            <h4>STCW Training</h4>
            <p>DG Shipping-approved safety, fire, and survival training for all merchant navy roles.</p>
            </section>
          </div>
        </div>
        
      </div>

      {/* ✅ Image + text section (left image) */}
      <div className="row align-items-center mb-5 service-row">
        <div className="col-md-6">
          <img src="/images/slide3.jpg" alt="Service 1" className="img-fluid rounded" />
        </div>
        <div className="col-md-6 ps-md-5 mt-3 mt-md-0">
            <section className='hover-fill'>
          <h4>Port Agency & Operations</h4>
          <p>We manage port clearances, crew changes, logistics, and documentation for smooth ship turnaround at major ports.</p>
        </section>
        </div>
      </div>

      {/* ✅ Image + text section (right image) */}
      <div className="row align-items-center service-row">
        <div className="col-md-6 pe-md-5 order-2 order-md-1 mt-3 mt-md-0">
          <h4>Marine Engineering Consultancy</h4>
          <p>Our experienced marine engineers assist with vessel inspections, machinery maintenance, audits, and onboard solutions.</p>
        </div>
        <div className="col-md-6 order-1 order-md-2">
            <section className='hover-fill'>
          <img src="/images/slide7.jpg" alt="Service 2" className="img-fluid rounded" />
          </section>
        </div>
      </div>
    </div>
  );
}